/**
 * The type of Redux action which changes Google API state.
 *
 * {
 *     type: SET_GOOGLE_API_STATE
 * }
 * @public
 */
export const SET_GOOGLE_API_STATE = 'SET_GOOGLE_API_STATE';

/**
 * The type of Redux action which changes Google API profile state.
 *
 * {
 *     type: SET_GOOGLE_API_PROFILE
 * }
 * @public
 */
export const SET_GOOGLE_API_PROFILE = 'SET_GOOGLE_API_PROFILE';
